import type { LoginFormSubmitFn } from '../../form/LoginForm/LoginForm';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { postOauthLogin } from '../../lib/flotiq-client/auth-requests';
import { fetchOauthHelper } from '../../lib/flotiq-client/fetch-oauth-helper';
import { getLoginErrorText, getTestProps } from '../../lib/helpers';

import LoginForm from '../../form/LoginForm/LoginForm';
import Authentication from '../../hoc/Authentication/Authentication';

export type oauthLoginFormData = {
  _username: string;
  _password: string;
};

const testId = 'login';

const OauthLogin = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const activated = searchParams.get('activated');
  const status = searchParams.get('status');

  const error = useMemo(
    () => getLoginErrorText(status, t, activated),
    [t, activated, status],
  );

  const handlePost: LoginFormSubmitFn = async (values) => {
    const [body, error] = await fetchOauthHelper<oauthLoginFormData>(
      {
        _username: values.email,
        _password: values.password,
      },
      postOauthLogin,
      searchParams.toString(),
      t,
    );

    if (body?.url) {
      window.location.replace(body?.url);
      return [body?.url, error];
    } else {
      return ['', error];
    }
  };

  return (
    <>
      <title>{t('Global.LogInToFlotiq')}</title>
      <Authentication
        authButtons={false}
        headerText={t('Global.LogInToFlotiq')}
        {...getTestProps(testId, 'authentication', 'testId')}
      >
        <LoginForm
          buttonText={activated === 'true' ? t('Activation.True') : ''}
          error={error}
          showResetPassword={false}
          onSubmit={handlePost}
          {...getTestProps(testId, 'form', 'testId')}
        />
      </Authentication>
    </>
  );
};

export default OauthLogin;
